import { render } from "./Biography.vue?vue&type=template&id=157fe3c3&ts=true"
import script from "./Biography.vue?vue&type=script&lang=ts"
export * from "./Biography.vue?vue&type=script&lang=ts"

import "./Biography.vue?vue&type=style&index=0&id=157fe3c3&lang=scss"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__